/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {number}
     * @memberof User
     */
    readonly userId?: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    readonly phone?: string;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    patronymicName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    docsIsUploaded?: boolean;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'patronymicName': !exists(json, 'patronymicName') ? undefined : json['patronymicName'],
        'docsIsUploaded': !exists(json, 'docsIsUploaded') ? undefined : json['docsIsUploaded'],
    };
}

export function UserToJSON(value?: User | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'patronymicName': value.patronymicName,
        'docsIsUploaded': value.docsIsUploaded,
    };
}


